module.exports = __webpack_public_path__ + "img/baipei3.94350693.jpg";